import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'store/create-store';
import { IPartnersState, IPartners } from 'store/partners/types';
import { getUserClientId } from 'selectors/user';
import { sameId } from 'helpers/utils';

export const getPartnersState = (state: RootState): IPartnersState => state.partners;

export const getPartnersData = createSelector(
  [getPartnersState],
  (state: IPartnersState): IPartners[] => state.data?.partners
);

export const getSubscriptionLevel = createSelector(
  [getPartnersState, getUserClientId],
  (partnersState: IPartnersState, clientID: number | null): string => {
    const partners = partnersState.data?.partners;
    if (!partners?.length || !clientID) return '';
    const partner = partners.find(p => sameId(p.client_id, clientID));
    return partner?.subscription_level ?? '';
  }
);
